"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

function Option(props) {
  // eslint-disable-next-line react/prop-types
  var innerProps = props.innerProps,
      innerRef = props.innerRef,
      isSelected = props.isSelected,
      isDisabled = props.isDisabled,
      isMulti = props.isMulti,
      children = props.children,
      optionData = props.data,
      selectProps = props.selectProps;

  function getHighlightedText(string, highlight) {
    var sanitized = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    // Split on highlight term and include term into parts, ignore case

    var parts = string.split(new RegExp("(".concat(sanitized, ")"), 'gi'));
    var style = {
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '20px'
    };
    return _react["default"].createElement("span", null, parts.map(function (part, index) {
      return _react["default"].createElement("span", {
        key: "".concat(part, "-").concat(string, "-").concat(index),
        style: (0, _objectSpread2["default"])({}, style, {
          fontWeight: part.toLowerCase() === highlight.toLowerCase() ? 'bold' : 400
        })
      }, part);
    }));
  }

  var labelClick = function labelClick() {
    if (isMulti && !selectProps.isMultiWithChips) {// selectProps.setLocalState(!isSelected, optionData);
    }
  };

  return _react["default"].createElement(_reactSelect.components.Option, props, _react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({
    buttonRef: innerRef,
    selected: isSelected,
    disabled: isDisabled,
    disableGutters: true,
    component: "div"
  }, innerProps, {
    // onMouseUp={labelClick}
    classes: {
      root: selectProps.classes.option,
      selected: selectProps.classes.selected
    }
  }), isMulti && _react["default"].createElement(_Checkbox["default"], {
    checked: isSelected,
    className: selectProps.classes.multiSelectCheckbox
  }), getHighlightedText(children, selectProps.inputValue || '')));
}

var _default = Option;
exports["default"] = _default;